export default "<a (click)=\"openTip($event, field)\" class=\"form-tip link link--primary font-text--medium hidden-lg hidden-md\">Dica</a>"